module.exports = __webpack_public_path__ + "media/property_transaction_process/person-a1a1a8c7.svg";